import { selectFeatureIncludes, FeatureDict } from '@authed/selectors'
import { useSettings } from '@datasets/dataset-details/hooks/useSettings'
import { useAppSelector } from '@redux/hooks'

/**
 * Returns whether the approval feature is enabled and the dataset requires approval.
 */
export const useApprovalSettings = () => {
  const [APPROVAL_ENABLED = false] = useAppSelector(selectFeatureIncludes([FeatureDict.APPROVAL]))
  const { requireApproval } = useSettings()
  const isRequiringApproval = APPROVAL_ENABLED && requireApproval

  return {
    isRequiringApproval,
  }
}
